var map = {
	"./Afghanistan.png": 4489,
	"./Afrique du Sud.png": 6622,
	"./Albanie.png": 4400,
	"./Algérie.png": 9960,
	"./Allemagne.png": 6229,
	"./Andorre.png": 4792,
	"./Angleterre.png": 8038,
	"./Angola.png": 6821,
	"./Antigua-et-Barbuda.png": 5565,
	"./Arabie Saoudite.png": 2862,
	"./Argentine.png": 2397,
	"./Arménie.png": 3086,
	"./Aruba.png": 6529,
	"./Athlètes Individuels Neutres.png": 2410,
	"./Australie.png": 4129,
	"./Autriche.png": 5595,
	"./Azerbaïdjan.png": 5167,
	"./Bahamas.png": 9951,
	"./Bahreïn.png": 2743,
	"./Bangladesh.png": 2039,
	"./Barbade.png": 2457,
	"./Belgique.png": 4743,
	"./Belize.png": 2491,
	"./Bermudes.png": 9090,
	"./Bhoutan.png": 7000,
	"./Birmanie.png": 8438,
	"./Bolivie.png": 579,
	"./Bosnie-Herzégovine.png": 8008,
	"./Botswana.png": 1003,
	"./Brunei.png": 5891,
	"./Brésil.png": 7004,
	"./Bulgarie.png": 6675,
	"./Burkina Faso.png": 9258,
	"./Burundi.png": 4168,
	"./Bénin.png": 9267,
	"./Cambodge.png": 5350,
	"./Cameroun.png": 7304,
	"./Canada.png": 3196,
	"./Cap Vert.png": 9194,
	"./Chili.png": 8409,
	"./Chine.png": 4037,
	"./Chypre.png": 5371,
	"./Colombie.png": 8075,
	"./Comores.png": 4510,
	"./Corée du Nord.png": 4090,
	"./Corée du Sud.png": 3745,
	"./Costa Rica.png": 5584,
	"./Croatie.png": 979,
	"./Cuba.png": 9440,
	"./Côte d'Ivoire.png": 1488,
	"./Danemark.png": 5505,
	"./Djibouti.png": 644,
	"./Dominique.png": 8702,
	"./Ecosse.png": 268,
	"./Espagne.png": 7216,
	"./Estonie.png": 2287,
	"./Eswatini.png": 8846,
	"./Fidji.png": 3213,
	"./Finlande.png": 8212,
	"./France.png": 3389,
	"./Gabon.png": 513,
	"./Gambie.png": 5816,
	"./Ghana.png": 8243,
	"./Gibraltar.png": 7609,
	"./Grande-Bretagne.png": 6273,
	"./Grenade.png": 7330,
	"./Grèce.png": 9533,
	"./Guam.png": 1380,
	"./Guatemala.png": 4194,
	"./Guinée Equatoriale.png": 5297,
	"./Guinée-Bissau.png": 3359,
	"./Guinée.png": 244,
	"./Guyana.png": 3160,
	"./Géorgie.png": 6725,
	"./Haiti.png": 5494,
	"./Honduras.png": 2438,
	"./Hong Kong.png": 1364,
	"./Hongrie.png": 8577,
	"./Inde.png": 8307,
	"./Indonésie.png": 549,
	"./Irak.png": 6947,
	"./Iran.png": 6937,
	"./Irlande du Nord.png": 602,
	"./Irlande.png": 7049,
	"./Islande.png": 4113,
	"./Israël.png": 4054,
	"./Italie.png": 5353,
	"./Jamaïque.png": 4261,
	"./Japon.png": 8864,
	"./Jordanie.png": 5605,
	"./Kazakhstan.png": 5465,
	"./Kenya.png": 8498,
	"./Kirghizistan.png": 6861,
	"./Kiribati.png": 1415,
	"./Kosovo.png": 7314,
	"./Koweït.png": 8752,
	"./Laos.png": 7521,
	"./Lettonie.png": 8749,
	"./Liban.png": 7601,
	"./Liberia.png": 5640,
	"./Libye.png": 9830,
	"./Liechtenstein.png": 5161,
	"./Lituanie.png": 7971,
	"./Luxembourg.png": 7176,
	"./Macédoine du Nord.png": 6546,
	"./Madagascar.png": 4762,
	"./Malaisie.png": 6243,
	"./Malawi.png": 2309,
	"./Maldives.png": 172,
	"./Mali.png": 6288,
	"./Malte.png": 1636,
	"./Maroc.png": 6123,
	"./Maurice.png": 7192,
	"./Mauritanie.png": 8346,
	"./Mexique.png": 5293,
	"./Micronésie.png": 5449,
	"./Moldavie.png": 5820,
	"./Monaco.png": 2320,
	"./Mongolie.png": 9483,
	"./Monténégro.png": 2139,
	"./Mozambique.png": 4837,
	"./Namibie.png": 2308,
	"./Nauru.png": 1595,
	"./Nicaragua.png": 9003,
	"./Niger.png": 5835,
	"./Nigeria.png": 3525,
	"./Norvège.png": 8127,
	"./Nouvelle-Zélande.png": 3344,
	"./Népal.png": 2706,
	"./Oman.png": 235,
	"./Ouganda.png": 7773,
	"./Ouzbékistan.png": 6246,
	"./Pakistan.png": 7302,
	"./Palaos.png": 5764,
	"./Palestine.png": 6713,
	"./Panama.png": 5808,
	"./Papouasie-Nouvelle-Guinée.png": 2258,
	"./Paraguay.png": 1465,
	"./Pays de Galles.png": 4239,
	"./Pays-Bas.png": 3785,
	"./Philippines.png": 1598,
	"./Pologne.png": 5643,
	"./Porto Rico.png": 8554,
	"./Portugal.png": 4704,
	"./Pérou.png": 6893,
	"./Qatar.png": 3059,
	"./Roumanie.png": 5452,
	"./Russie.png": 2478,
	"./Rwanda.png": 2247,
	"./République Dominicaine.png": 5075,
	"./République Démocratique du Congo.png": 431,
	"./République du Congo.png": 9053,
	"./Saint-Christophe-et-Niévès.png": 6660,
	"./Saint-Marin.png": 4404,
	"./Saint-Vincent-et-les-Grenadines.png": 9838,
	"./Sainte-Lucie.png": 3933,
	"./Salomon.png": 6775,
	"./Salvador.png": 3021,
	"./Samoa américaines.png": 8327,
	"./Samoa.png": 1786,
	"./Sao Tomé-et-Principe.png": 6639,
	"./Serbie.png": 4058,
	"./Seychelles.png": 5803,
	"./Sierra Leone.png": 3335,
	"./Singapour.png": 4984,
	"./Slovaquie.png": 2017,
	"./Slovénie.png": 8965,
	"./Somalie.png": 3804,
	"./Soudan du Sud.png": 9687,
	"./Soudan.png": 2677,
	"./Sri Lanka.png": 6957,
	"./Suisse.png": 5646,
	"./Suriname.png": 3565,
	"./Suède.png": 5299,
	"./Syrie.png": 2210,
	"./Sénégal.png": 2734,
	"./Tadjikistan.png": 7771,
	"./Taipei Chinois.png": 9675,
	"./Tanzanie.png": 934,
	"./Tchad.png": 1770,
	"./Tchéquie.png": 2756,
	"./Thaïlande.png": 2317,
	"./Timor oriental.png": 6696,
	"./Togo.png": 8341,
	"./Tonga.png": 7120,
	"./Trinité-et-Tobago.png": 3599,
	"./Tunisie.png": 6446,
	"./Turkménistan.png": 8203,
	"./Turquie.png": 2276,
	"./Tuvalu.png": 2124,
	"./Ukraine.png": 4668,
	"./Uruguay.png": 8755,
	"./Vanuatu.png": 7363,
	"./Venezuela.png": 4937,
	"./Viêt Nam.png": 5496,
	"./Yémen.png": 9512,
	"./Zambie.png": 2866,
	"./Zimbabwe.png": 2290,
	"./Égypte.png": 2153,
	"./Émirats Arabes Unis.png": 3530,
	"./Équateur.png": 8971,
	"./Équipe Olympique des Réfugiés.png": 5897,
	"./Érythrée.png": 3657,
	"./États-Unis.png": 5604,
	"./Éthiopie.png": 2676,
	"./Îles Caïmans.png": 1571,
	"./Îles Cook.png": 866,
	"./Îles Marshall.png": 2119,
	"./Îles Vierges britanniques.png": 200,
	"./Îles Vierges des États-Unis.png": 491
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3496;